export default __webpack_public_path__ + "static/media/icon-very-happy-face-full.339c4cce.svg";